import * as XLSX from "xlsx";

export type ExcelCell = string | number | boolean | Date | null;

export type ExcelSheet = {
  name: string;
  rows: ExcelCell[][];
  columns: number;
};

export type ExcelResult = {
  fileName: string;
  sheets: ExcelSheet[];
};

export async function readExcelFile(
  file: File
): Promise<ExcelResult> {
  const buffer = await file.arrayBuffer();

  const workbook = XLSX.read(buffer, {
    type: "array",
    cellDates: true,
  });

  const sheets: ExcelSheet[] = workbook.SheetNames.map(
    (sheetName) => {
      const worksheet = workbook.Sheets[sheetName];

      const rows = XLSX.utils.sheet_to_json<ExcelCell[]>(
        worksheet,
        {
          header: 1,
          defval: null,
          raw: true,
        }
      );

      const columns = rows.reduce(
        (max, row) => Math.max(max, row.length),
        0
      );

      const normalizedRows = rows.map((row) => [
        ...row,
        ...Array(columns - row.length).fill(null),
      ]);

      return {
        name: sheetName,
        rows: normalizedRows,
        columns,
      };
    }
  );

  return {
    fileName: file.name,
    sheets,
  };
}
